<template>
  <v-card
    v-if="getPopularCategory()"
    class="align-center justify-start rounded-lg pt-10 text-center white--text"
    flat
    color="defaultColorLightTwo"
    height="190"
    width="190"
    @click="$emit('selectCategory', item)"
  >
    <v-card-title
      class="mx-4 pa-0 text-center justify-center align-center white--text"
      style="word-break: break-word"
    >
      <v-avatar tile size="65">
        <v-img
          :src="require('@/../public/images/category/' + getItemIcon()).default"
          contain
        >
        </v-img>
      </v-avatar>
    </v-card-title>
    <v-card-title
      class="mx-4 pa-0 mt-3 white--text text-center justify-center"
      style="word-break: break-word; font-size: 14px; line-height: 20px"
    >
      <h3 class="mx-5 mt-3 text-center font-weight-medium">
        {{ item.CategoryNameTR }}
      </h3>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    item: Object,
  },
  mounted() {},
  methods: {
    //TODO: servisten populer kategoriler geldiğinde bu kontroller kaldırılacak

    getItemIcon() {
      console.log("this.item.CategoryNameTR :", this.item.CategoryNameTR);
      switch (this.item.CategoryNameTR) {
        case "POSITIVE":
          return "Positive.png";
        case "SR Dekatlon":
          return "srdekatlon.png";
        case "Markalarımız":
          return "stars.png";
        case "Pazarlama Gelişim (MSD)":
          return "announcement.png";
        case "Video Kütüphanesi":
          return "video.png";
        case "Arşiv":
          return "archive.png";
        default:
          return "Positive.png";
      }
    },

    getPopularCategory() {
      switch (this.item.CategoryNameTR) {
        case "Markalarımız":
        case "Video Kütüphanesi":
        case "Pazarlama Gelişim (MSD)":
        case "POSITIVE":
        case "SR Dekatlon":
        case "Arşiv":
          return true;
        default:
          return false;
      }
    },
  },
  computed: {},
};
</script>
